import { SizableText, View } from 'tamagui'
import { hexToRgba, tonePairs, type BadgeTone } from '../utils/color'

export interface BadgeProps {
    /** Semantic tone — pulls theme-aware soft bg + solid fg tokens. */
    tone?: BadgeTone
    /** Explicit solid colour (hex). Soft background is derived from it. Overrides `tone`. */
    color?: string
    /** Show a leading dot in the foreground colour. */
    dot?: boolean
    children: React.ReactNode
    textTransform?: 'none' | 'capitalize' | 'uppercase'
}

/**
 * Soft-tinted pill badge (BuyerFlo design system).
 * Background is the colour at low alpha; text + optional leading dot use the solid colour.
 */
export function Badge({ tone = 'neutral', color, dot, children, textTransform = 'none' }: BadgeProps) {
    const bg = color ? hexToRgba(color, 0.14) : tonePairs[tone].bg
    const fg = color ?? tonePairs[tone].fg

    return (
        <View
            flexDirection="row"
            alignItems="center"
            gap="$1.5"
            alignSelf="flex-start"
            height={22}
            paddingHorizontal="$2.5"
            borderRadius={999}
            backgroundColor={bg}
        >
            {dot ? (
                <View
                    width={6}
                    height={6}
                    borderRadius={999}
                    backgroundColor={fg}
                />
            ) : null}
            <SizableText
                fontSize={11.5}
                lineHeight={16}
                fontWeight="500"
                color={fg}
                textTransform={textTransform}
            >
                {children}
            </SizableText>
        </View>
    )
}
